import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';

export const ModalCustom = styled(Modal)``;
